<template>
  <L1 id="attendance">
    <template slot="slot_title">
      <RadioTop  :options="['排班紀錄', '排班月曆', '出勤結算']"
       :defaultValue="$route.query.page" @input="$router.replace({ name: $route.name, query: { page: $event } }) "/>
    </template>
    <Page2  v-if="$route.query.page==='出勤結算' "/>
    <Page3  v-else-if="$route.query.page==='排班月曆' "/>
    <Page1  v-else/>
  </L1>
</template>

<script>
import Page3 from './page3.vue'
import Page1 from './page1.vue'
import Page2 from './page2.vue'
import RadioTop from '../../components/radio/r1.vue'
import L1 from '../../components/layout/L1.vue'
export default {
  components: {
    L1,
    RadioTop,
    Page1,
    Page2,
    Page3
  }
}
</script>
